import { exists } from '@/api'

export interface BatchCollectionMgmtRemovalListConditionListItem {
  processDateFrom: string
  processDateTo: string
  holdingBranch: string
  removeReason: string
  isOutputList: boolean
  isOutputStatistics: boolean
  rdoOutputOrder: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtRemovalListConditionListItemFromJSON(
  json: any
): BatchCollectionMgmtRemovalListConditionListItem {
  const resp = JSON.parse(json)

  return {
    processDateFrom: exists(resp, 'process_date_from')
      ? resp.process_date_from
      : '',
    processDateTo: exists(resp, 'process_date_to') ? resp.process_date_to : '',
    holdingBranch: exists(resp, 'holding_branch') ? resp.holding_branch : '',
    removeReason: exists(resp, 'remove_reason') ? resp.remove_reason : '',
    isOutputList: exists(resp, 'is_output_list') ? resp.is_output_list : false,
    isOutputStatistics: exists(resp, 'is_output_statistics')
      ? resp.is_output_statistics
      : false,
    rdoOutputOrder: exists(resp, 'rdo_output_order')
      ? resp.rdo_output_order
      : '1',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
